module.exports = __webpack_public_path__ + "static/media/morning@3x.7fd39d51.png";